// ============================================================
// 导航：滚动状态 + 实时时钟 + 移动端菜单 + 滚动高亮
// ============================================================

const SECTION_IDS = ["home", "works", "about", "contact"];

export default function initNav() {
  const nav = document.getElementById("nav");
  const toggle = document.getElementById("nav-toggle");
  const menu = document.getElementById("mobile-menu");
  const clock = document.getElementById("nav-clock");
  if (!nav || !toggle || !menu) return;

  // 滚动状态 + Scrollspy
  const onScroll = () => {
    nav.classList.toggle("is-scrolled", window.scrollY > 10);

    let current = "home";
    SECTION_IDS.forEach((id) => {
      const el = document.getElementById(id);
      if (el && el.getBoundingClientRect().top <= 140) current = id;
    });

    document
      .querySelectorAll(".nav-link, .mobile-menu a[data-nav]")
      .forEach((a) => {
        a.classList.toggle("is-active", a.dataset.nav === current);
      });
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  // 实时时钟
  const updateClock = () => {
    if (!clock) return;
    const d = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    clock.textContent = `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(
      d.getSeconds()
    )}`;
  };
  updateClock();
  setInterval(updateClock, 1000);

  // 移动端菜单
  const closeMenu = () => {
    toggle.classList.remove("is-open");
    menu.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
    menu.setAttribute("aria-hidden", "true");
  };

  toggle.addEventListener("click", () => {
    const isOpen = menu.classList.toggle("is-open");
    toggle.classList.toggle("is-open", isOpen);
    toggle.setAttribute("aria-expanded", String(isOpen));
    menu.setAttribute("aria-hidden", String(!isOpen));
  });

  menu.querySelectorAll("a").forEach((a) => a.addEventListener("click", closeMenu));

  window.addEventListener("resize", () => {
    if (window.innerWidth > 768) closeMenu();
  });
}
